import { getSoftSetting } from "@/services/softSetting";
import { useQuery } from "@tanstack/react-query";

function useSoftSetting() {
  return useQuery({
    queryKey: ["softsetting"],
    queryFn: getSoftSetting,
    staleTime: 1000 * 60 * 10,
    retry: 2,
    retryDelay: 1000,
  });
}

export default useSoftSetting;
